﻿import { ChevronRight, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import styles from "./settings-sidebar.module.scss";

const SettingsSidebar = ({ sections, activeSection, onSectionChange }) => {
	const navigate = useNavigate();

	return (
		<aside className={styles.sidebar}>
			<div className={styles.sidebarHeader}>
				<div className={styles.sidebarHeaderTop}>
					<button className={styles.backButton} onClick={() => navigate(-1)} type="button">
						<ArrowLeft size={15} />
					</button>
					<div>
						<h2 className={styles.sidebarTitle}>Configuración</h2>
						<p className={styles.sidebarSubtitle}>Administra los ajustes de tu cuenta</p>
					</div>
				</div>
			</div>

			<nav className={styles.sidebarNav}>
				{sections.map((section) => (
					<button
						key={section.key}
						className={`${styles.sidebarItem} ${activeSection === section.key ? styles.active : ""}`}
						onClick={() => onSectionChange(section.key)}
						type="button"
					>
						<div className={styles.sidebarItemIcon}>
							<section.Icon size={20} />
						</div>
						<div className={styles.sidebarItemContent}>
							<span className={styles.sidebarItemTitle}>{section.title}</span>
							<span className={styles.sidebarItemSubtitle}>{section.subtitle}</span>
						</div>
						{section.count > 0 && <span className={styles.sidebarItemBadge}>{section.count}</span>}
					</button>
				))}
			</nav>

			<div className={styles.sidebarFooter}>
				<div className={styles.helpCard}>
					<h3>Documentación API</h3>
					<p>Explora los endpoints y recursos disponibles.</p>
					<a href="https://documenter.getpostman.com/view/6886437/2s93CLrDQP" target="_blank" rel="noopener noreferrer" className={styles.helpLink}>
						Ver documentación API <ChevronRight size={16} />
					</a>
				</div>
			</div>
		</aside>
	);
};

export default SettingsSidebar;
